import { api, unwrap } from '@/core/http';
import type { EventBody } from '../domain/event';

const ev = (event_id: string) => ({ params: { path: { event_id } } });

export const eventsApi = {
  list: () => unwrap(api.GET('/v1/events')),
  get: (id: string) => unwrap(api.GET('/v1/events/{event_id}', ev(id))),
  create: (body: EventBody) => unwrap(api.POST('/v1/events', { body })),
  update: (id: string, body: EventBody) => unwrap(api.PUT('/v1/events/{event_id}', { ...ev(id), body })),
  publish: (id: string) => unwrap(api.POST('/v1/events/{event_id}/publish', ev(id))),
  unpublish: (id: string) => unwrap(api.POST('/v1/events/{event_id}/unpublish', ev(id))),
  cancel: (id: string) => unwrap(api.POST('/v1/events/{event_id}/cancel', ev(id))),
  remove: (id: string) => unwrap(api.DELETE('/v1/events/{event_id}', ev(id))),
  registrations: (id: string) => unwrap(api.GET('/v1/events/{event_id}/registrations', ev(id))),
};
